import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { SEOHead } from '../components';
import { ArrowLeft } from 'lucide-react';

/**
 * Public marketing page: eigenLeads
 * Replace placeholder copy when final content location is provided.
 */
const EigenLeads = () => {
  const { theme } = useTheme();

  return (
    <div className={theme === 'dark' ? 'bg-slate-950 text-slate-100' : 'bg-white text-slate-700'}>
      <SEOHead
        title="eigenLeads"
        description="eigenLeads — Shared Oxygen product research for executive growth decisions."
        type="website"
      />

      <section
        className={`${theme === 'dark' ? 'bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950' : 'bg-gradient-to-br from-white via-blue-50 to-slate-50'} py-16 lg:py-24`}
      >
        <div className="max-w-3xl mx-auto px-6 space-y-6">
          <Link
            to="/"
            className={`inline-flex items-center gap-2 text-sm font-medium ${theme === 'dark' ? 'text-blue-400 hover:text-blue-300' : 'text-blue-600 hover:text-blue-800'}`}
          >
            <ArrowLeft size={16} aria-hidden />
            Shared Oxygen
          </Link>
          <p className="text-xs uppercase tracking-[0.35em] text-slate-400">Product Research</p>
          <h1 className="text-4xl lg:text-5xl font-semibold tracking-tight">eigenLeads</h1>
          <p className="text-lg text-slate-600 dark:text-slate-300">
            Product research for AI-enabled lead intelligence, pipeline quality, and growth accountability.
          </p>
        </div>
      </section>

      <section className="py-16 border-t border-slate-200/80 dark:border-slate-800">
        <div className="max-w-3xl mx-auto px-6 prose prose-slate dark:prose-invert">
          <h2 className="text-xl font-semibold text-slate-900 dark:text-slate-100">Research Preview</h2>
          <p className="text-slate-600 dark:text-slate-300">
            Final positioning and proof points will be added when source content is available.
          </p>
        </div>
      </section>
    </div>
  );
};

export default EigenLeads;
